import React, { useEffect, useState } from 'react';
import { Button, Card, CrudIcon, Table, Title } from 'src/components';
import Chart from 'src/components/chart';
import { DashboardLayout } from 'src/containers';
import DashboardTable from 'src/components/table/dashboardTable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { BiFilterAlt } from 'react-icons/bi';
import { Tables } from 'src/pages';
import useFetch from 'src/hooks/useFetch';
import Search from 'src/components/search';
import { AiOutlineEye, AiOutlinePlus } from 'react-icons/ai';
import { FaDoorClosed } from 'react-icons/fa';
import Service from 'src/setup/network';
import { useNavigate, useParams } from 'react-router-dom';
import AddEditShifts from '../shift/components/AddShifts';
import AddEditCash from './components/AddCash';
import { MdEdit } from 'react-icons/md';
import { oneMonthAgoDate } from 'src/utils/dateOneMonthAgo';
import { BsArrowLeft } from 'react-icons/bs';
import DateFormat from 'src/components/DateFormat';

interface IProps {}

const CashReport: React.FC<IProps> = ({}) => {
  const { id } = useParams();
  const [startDate, setStartDate] = useState(oneMonthAgoDate);
  const [endDate, setEndDate] = useState(new Date());
  const [query, setQuery] = React.useState('');
  const [showModal, setShowModal] = React.useState(false);
  const [editCash, setEditCash] = React.useState(false);
  const [cashData, setCashData] = React.useState([]);
  const [editCashData, setEditCashData] = React.useState([]);
  const [editCashId, setEditCashId] = React.useState('');
  const navigate = useNavigate();

  const fetchCashData = async () => {
    try {
      const response = await Service.get(`shifts/details/${id}`);
      const data = await response?.data?.cashDrawerInfo?.allCashTransactions;
      setCashData(data);
    } catch (err: any) {}
  };
  useEffect(() => {
    fetchCashData();
  }, [endDate]);

  const handleDateChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  const handleEditCash = (data: any) => {
    setEditCash(!editCash);
    setEditCashData(data);
    setEditCashId(data?.id);
    setShowModal(true);
  };

  const tableColumn = React.useMemo(
    () => [
      {
        Header: 'Time',
        accessor: 'createdAt',
        Cell: (row: any) => (
          <div>{<DateFormat text={row?.cell?.row?.original?.createdAt} />}</div>
        ),
      },
      {
        Header: 'User',
        accessor: 'user',
      },
      {
        Header: 'Type',
        accessor: 'type',
        Cell: (row: any) => {
          return (
            <>
              <p>
                {row?.cell?.row?.original?.type === 'incoming'
                  ? 'Cash Payment'
                  : row?.cell?.row?.original?.type === 'outgoing'
                  ? 'Cash Refund'
                  : row?.cell?.row?.original?.type === 'Cash In'
                  ? 'Cash In'
                  : row?.cell?.row?.original?.type === 'Cash Out'
                  ? 'Cash Out'
                  : ''}
              </p>
            </>
          );
        },
      },
      { Header: 'Note', accessor: 'note' },
      {
        Header: 'Amount',
        accessor: 'amount',
      },
    ],
    []
  );
  const handleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="  w-11/12  flex items-center justify-end">
        <div className=" ml-4 text-black col-span-12 md:col-span-12 xl:col-span-12 2xl:col-span-8 flex item-center justify-end ">
          <div className="flex space-x-4">
            {/* <DatePicker
                name="date"
                className="w-[fit] appearance-none rounded-xl text-text-black placeholder:capitalize rounded py-3 block placeholder:text-sm px-3 text-sm ring-1 ring-light-grey focus-within:ring-1 focus-within:ring-primary focus-within:outline-0 border-light-gray"
                locale="en-US"
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                placeholderText="MM-DD-YYYY"
              /> */}
          </div>
        </div>
      </div>

      <div className="w-11/12 pb-10">
        <Table
          tableColumn={tableColumn}
          tableData={cashData}
          pagination={true}
        />
      </div>
    </>
  );
};

export default CashReport;
